import React from 'react';
/**
 * This is defined here so we can supply a lazy component from the package,
 * while keeping the standard component as the default.
 */
export var LazyRecommendedSuspenseComponent = React.lazy(
/* webpackChunkName: "recommended-suspense */
function () { return import('./RecommendedSuspenseComponent'); });
//# sourceMappingURL=RecommendedLazySuspenseComponent.js.map